import { render, staticRenderFns } from "./confirm-bar-checkbox.vue?vue&type=template&id=2b2bd138&lang=pug"
import script from "./confirm-bar-checkbox.vue?vue&type=script&lang=js"
export * from "./confirm-bar-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports